// TODO update this to import from commmons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';
import I18n from 'i18n-js';
import React from 'react';
import { withRouter, WithRouterProps } from 'react-router';

import CombineAndSaveRow from './discovery/combine_and_save_row';
import { LISTING_STATES } from '@reverbdotcom/commons/src/constants';
import { V3 } from './api_request';
import UrlHelpers from './shared/url_helpers';
import RelatedArticles from './shared/related_articles';
import ComparisonShoppingPage from './discovery/csp/comparison_shopping_page';
import CSPSquareRow from './discovery/csp/csp_square_row';
import { core_apimessages_ShippingMethod, ItemFooterFields, SimilarListingsFields } from '@reverbdotcom/commons/src/gql/graphql';
import RecentlyViewedCspsRow from './recently_viewed_csps_row';
import RecommendedShopsRow, { RecommendedShopsRowListingFragment } from './recommended_shops_row';
import SimilarListingsRow from './discovery/similar_listings_row';
import SimilarListingsRowWithQuery from './discovery/similar_listings_row_with_query';

import RecentlyViewedListings from '@reverbdotcom/commons/src/cms/components/recently_viewed_listings';
import bind from '@reverbdotcom/commons/src/bind';
import { withUserContext, IUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';
import SimilarCspsRow from '@reverbdotcom/commons/src/components/similar_csps_row';
import Item2PromotedSimilarListingsRow from './recommended_listings/item_2_promoted_similar_listings_row';
import {
  showItemPageListingFlags,
  localizedSimilarListingsTitle,
  showLocalizedListingContent,
  showShopRow,
} from '@reverbdotcom/commons/src/localize_listing_rows_utils';
import { connect } from '@reverbdotcom/commons/src/connect';
import { withPrefix } from '@reverbdotcom/commons/src/i18n_helpers';
import { MParticlePageName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

interface Listing extends ItemFooterFields.Fragment {
  similarListings?: SimilarListingsFields.Fragment[];
}

interface ExternalProps {
  listing: Listing;
}

type OwnProps = IUserContext & WithRouterProps;

interface IState {
  articles: any[];
  alsoViewedCsps: any[];
  isEmptyCSPRow: boolean;
}

type IProps = ExternalProps & OwnProps;

const t = withPrefix('discovery.itemShow');

function listingId(props: OwnProps): string {
  return props.params.id.split('-')[0];
}

export class Item2Footer extends React.Component<IProps, IState> {
  state = {
    articles: [],
    alsoViewedCsps: [],
    isEmptyCSPRow: false,
  };

  componentDidMount() {
    this.fetchRelatedArticles();
    this.fetchAlsoViewedCsps();
  }

  get cspSlug() {
    return this.props.listing?.csp?.slug;
  }

  get showLocalizedListingContent() {
    return showLocalizedListingContent(this.props.user);
  }

  get showItemPageListingFlags() {
    return showItemPageListingFlags(this.props.user);
  }

  get showShopRow() {
    return showShopRow(this.props.user) && this.isListingStateLive;
  }

  get similarListingsTitle() {
    return localizedSimilarListingsTitle(this.props.user);
  }

  get isListingStateLive() {
    return this.props.listing.state === LISTING_STATES.LIVE;
  }

  get showSimilarListingsRow() {
    if (this.showLocalizedListingContent && !this.isListingStateLive) return false;

    return !this.cspSlug ||
      this.showLocalizedListingContent ||
      this.state.isEmptyCSPRow;
  }

  fetchRelatedArticles() {
    V3.get(
      UrlHelpers.relatedArticlesToListing(this.listingId()),
    ).then((response) => {
      if (!response) { return; }
      this.setState({ articles: response.articles });
    });
  }

  listingId = () => {
    return listingId(this.props);
  };

  tableParam = () => {
    return this.props.location.query.table;
  };

  fetchAlsoViewedCsps() {
    V3.get(
      UrlHelpers.similarCSPsPath('also_viewed'),
      { per_page: 6, listing_id: this.listingId(), table: this.props.location.query.table },
    ).then((response) => {
      if (!response) { return; }

      if (response.comparison_shopping_pages.length) {
        const csps = response.comparison_shopping_pages.map(this.toCSP);
        this.setState({ alsoViewedCsps: csps });
      }
    }).fail((_xhr, status, err) => { throw new Error(`could not fetch also viewed csps - status: ${status}, err: ${err}`); });
  }

  @bind
  toCSP(page) {
    if (page.id === this.listingId()) return null;
    return new ComparisonShoppingPage(page);
  }

  @bind
  onSimilarCspsRowEmpty() {
    this.setState({ isEmptyCSPRow: true });
  }

  renderSimilarListings() {
    if (this.isListingStateLive) {
      return (
        <SimilarListingsRowWithQuery
          data-similar-listings-row
          listingId={this.listingId()}
          title={this.similarListingsTitle}
          showFlags={this.showItemPageListingFlags}
        />
      );
    }

    return (
      <SimilarListingsRow
        data-similar-listings-row
        similarListings={this.props.listing?.similarListings}
        title={this.similarListingsTitle}
        showFlags={this.showItemPageListingFlags}
      />
    );
  }

  renderSimilarCSPsOrListings() {
    return (
      <>
        {this.showSimilarListingsRow &&
          this.renderSimilarListings()
        }
        {this.cspSlug &&
          <SimilarCspsRow
            title={(t('similarCsps'))}
            listingId={this.listingId()}
            cspSlugToHide={this.cspSlug}
            onEmpty={this.onSimilarCspsRowEmpty}
            listingState={this.props.listing?.state}
          />
        }
      </>
    );
  }

  renderAlsoViewedCSPs() {
    if (!this.state.alsoViewedCsps.length) return null;

    return (
      <CSPSquareRow
        pages={this.state.alsoViewedCsps}
        title={t('alsoViewedCsps')}
        trackName="AlsoViewed"
        loaded
      />
    );
  }

  renderPromotedSimilarListings() {
    const { listing } = this.props;

    return (
      <Item2PromotedSimilarListingsRow
        listing={listing}
        pageName={MParticlePageName.ItemPage}
      />
    );
  }

  listingStandardShippingRateCents(): number {
    const { listing } = this.props;
    const shippingPrices = listing.shipping?.shippingPrices || [];
    const standardShippingRate = shippingPrices.find(
      ({ shippingMethod }) => shippingMethod === core_apimessages_ShippingMethod.SHIPPED,
    );

    return standardShippingRate?.rate?.amountCents;
  }

  get showCombineAndSaveRow(): boolean {
    const { listing } = this.props;
    if (!this.isListingStateLive) { return false; }
    if (listing.shipping?.localPickupOnly) { return false; }

    return this.listingStandardShippingRateCents() > 0 || listing.combinedShippingParent;
  }

  render() {
    const { listing } = this.props;

    if (!listing) return null;

    return (
      <div className="item2__footer">
        {this.showShopRow &&
          <RecommendedShopsRow
            data-recommended-shops-row
            listingId={listing.id}
            brandSlug={listing.brandSlug}
            categorySlugs={listing.categories.map(category => category.slug)}
          />
        }
        {this.showCombineAndSaveRow && (
          <CombineAndSaveRow
            categoryRootUuid={listing.categoryRootUuid}
            excludedListingIds={[listing.id]}
            maxStandardRateDisplayCents={listing.combinedShippingParent ? null : this.listingStandardShippingRateCents()}
            shopId={listing.shopId}
            shopName={listing.shop.name}
            shopSlug={listing.shop.slug}
            trackingEntityId={listing.id}
            freeCombinedShippingParent={listing.combinedShippingParent && this.listingStandardShippingRateCents() === 0}
          />
        )}
        {this.renderSimilarCSPsOrListings()}
        {this.renderPromotedSimilarListings()}
        <RecentlyViewedCspsRow alwaysRender />
        {this.renderAlsoViewedCSPs()}
        <RecentlyViewedListings
          title={I18n.t('discovery.recentlyViewed.title')}
          showFlags={this.showItemPageListingFlags}
          largeTiles
          loggedOutExperiment
          ssr={false}
        />
        <RelatedArticles
          articles={this.state.articles}
          heading={t('relatedArticles')}
        />
      </div>
    );
  }
}

export const ItemFooterFragment = gql`
  fragment ItemFooterFields on Listing {
    _id
    id
    categoryRootUuid
    state
    shopId
    combinedShippingParent
    shop {
      _id
      name
      slug
      address {
        _id
        countryCode
      }
    }
    shipping {
      localPickupOnly
      shippingPrices {
        _id
        shippingMethod
        rate {
          amountCents
        }
      }
    }
    csp {
      _id
      slug
    }
    ...RecommendedShopsRowListingFields
  }
  ${RecommendedShopsRowListingFragment}
`;

const connected = connect<ExternalProps>([
  withRouter,
  withUserContext,
])(Item2Footer);

export default connected;
